import React from "react";
import Scrollchor from "react-scrollchor";
import Link from "gatsby-link";
import FadeIn from "../components/atoms/FadeIn";
import {
  HideMobile,
  ShowMobile,
  HideTablet
} from "../components/blocks/Responsive";
import styled from "styled-components";
import { r } from "../utils";
import Helmet from "react-helmet";
import { P, H1, H2, H3, H4, H5 } from "../components/typography";
import Spacer from "../components/blocks/Spacer";
import Pad from "../components/blocks/Pad";
import NavBar from "../components/NavBar";
import Emphasis from "../components/atoms/Emphasis";
import { InternalButton } from "../components/atoms/Button";
import Section from "../components/blocks/Section";
import ContentSection from "../components/blocks/ContentSection";
import ArrowLink, { ArrowBody } from "../components/ArrowLink";
import Timeline from "../components/Timeline";
import { getGraphNode } from "../selectors";
import WhatIf from "../components/WhatIf";
import TriangleBackground from "../components/blocks/TriangleBackground";
import Background from "../components/blocks/Background";
import favicon from "../../assets/logofavcon@2x.png";
import hillImg from "../../assets/hill-teal.png";
import caretWhiteImg from "../../assets/caret-white.png";

const TimelineQuote = H3.extend`
  padding-top: 4rem;
  display: flex;
  justify-content: center;
  text-align: center;
  font-weight: 400;
`;

const FDAFootNote = styled.div`
  position: absolute;
  bottom: 1rem;
  right: 2rem;
`;

const GloveSection = styled.div`
  width: 100%;
  ${r("padding-left", "16rem", 0)};
  ${r("padding-bottom", 0, "14rem")};
`;

const GlovePosition = styled.div`
  position: absolute;
  ${r("bottom", "-6rem", "-3rem")};
  display: block;
  ${r("height", "auto", "20rem")};
  ${r("top", "-3rem", "inherit")};
  ${r("left", "-8rem", "20vw")};
  ${r("right", "auto", "20vw")};
`;

const Glove = styled.img`height: 100%;`;

const HillArrow = () => {
  return (
    <div
      style={{
        position: "absolute",
        bottom: -6,
        left: 0,
        right: 0,
        display: "flex",
        justifyContent: "center"
      }}
    >
      <Scrollchor
        to="future"
        className="nav-link"
        style={{ position: "relative", cursor: "pointer" }}
        animate={{ offset: -60, duration: 600 }}
      >
        <img src={hillImg} style={{ height: 40, width: 146 }} />
        <img
          style={{ position: "absolute", top: 16, left: 64 }}
          src={caretWhiteImg}
        />
      </Scrollchor>
    </div>
  );
};

export default class Index extends React.Component {
  render() {
    const content = getGraphNode(this.props.data, "HomePage");
    return (
      <div>
        <Helmet
          title="Contraline"
          meta={[{ name: "Contraline", content: "HomePage" }]}
        >
          <link rel="icon" type="image/png" href={favicon} />
        </Helmet>
        <TriangleBackground>
          <NavBar color="dark" />
          <Section
            padLarge
            justify="center"
            align="center"
            vPad={false}
            style={{ flex: 1 }}
          >
            <WhatIf list={content.whatIfText.whatIfText.split("|")} />
            <HideMobile>
              <Spacer span={2} />
            </HideMobile>
          </Section>
          <HillArrow />
        </TriangleBackground>

        <div id="future" />
        <Background color="teal">
          <Pad v={6}>
            <ContentSection
              color="transparent"
              fontColor="white"
              titleText={content.futureTitle}
              bodyText={content.futureBodyText.futureBodyText.split("|")}
            />
          </Pad>
        </Background>
        <Background color="greyDient">
          <Section padLarge={false}>
            <Pad mv={1}>
              <Emphasis>
                <H4>
                  {content.timelineTitle}
                </H4>
              </Emphasis>
            </Pad>
            <Section>
              <Timeline entries={content.timelineEntries.entries} />
            </Section>
            <Spacer span={1} />
            <FadeIn>
              <TimelineQuote>
                {content.timelineConclusion}
              </TimelineQuote>
              <Spacer span={2} />
              <div
                style={{
                  textAlign: "center",
                  width: "100%"
                }}
              >
                <InternalButton to="/participate">
                  Follow our progress
                </InternalButton>
              </div>
            </FadeIn>
            <Spacer span={8} />
          </Section>
        </Background>

        <Section narrow fixed>
          <div style={{ position: "relative" }}>
            <GloveSection>
              <div className="content">
                <Spacer span={4} />
                <H3 serif weight="bold">
                  {content.productTitle}
                </H3>
                <HideMobile>
                  {content.productBodyText.productBodyText
                    .split("|")
                    .map(text =>
                      <P>
                        {text}
                      </P>
                    )}
                </HideMobile>
                <ShowMobile>
                  <P>
                    {content.productBodyText.productBodyText
                      .replace("|", "")
                      .replace("|", "")}
                  </P>
                </ShowMobile>
                <Pad v={0.75}>
                  <ArrowLink to="/product">
                    <P color="teal">
                      {content.productLink}
                    </P>
                  </ArrowLink>
                </Pad>
                <Spacer span={8} />
              </div>
            </GloveSection>
            <GlovePosition>
              <Glove src={content.glove.responsiveSizes.src} />
            </GlovePosition>
          </div>
        </Section>
      </div>
    );
  }
}

export const pageQuery = graphql`
  query HomePageQuery {
    allContentfulHomePage {
      edges {
        node {
          id
          futureTitle
          futureBodyText {
            futureBodyText
          }
          whatIfText {
            whatIfText
          }
          timelineTitle
          timelineEntries {
            entries {
              src
              date
              event
              bold
            }
          }
          timelineConclusion
          productTitle
          productBodyText {
            productBodyText
          }
          productLink
          glove {
            responsiveSizes(maxWidth: 600) {
              src
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js